import { render, staticRenderFns } from "./SharedServiceTag.vue?vue&type=template&id=23a5fca4&"
import script from "./SharedServiceTag.vue?vue&type=script&lang=js&"
export * from "./SharedServiceTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23a5fca4')) {
      api.createRecord('23a5fca4', component.options)
    } else {
      api.reload('23a5fca4', component.options)
    }
    module.hot.accept("./SharedServiceTag.vue?vue&type=template&id=23a5fca4&", function () {
      api.rerender('23a5fca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/SharedServiceTag.vue"
export default component.exports